import { useQuery } from '@tanstack/react-query';
import { getChargingService } from '../../api/charging-service.ts';
import { normalizeNulls } from '../../utils/normalizeNulls.ts';

export default function useChargingService(
  serviceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['chargingServices', serviceId],
    queryFn: async () => {
      return await getChargingService(serviceId);
    },
    select: normalizeNulls,
    enabled: !!serviceId && (options?.enabled ?? true),
  });
}
